import { inject, Injectable } from "@angular/core";
import { WK_DATATABLE_ID } from "@components/data-table/data-table.tokens";
import type { WkDataTableStoredColumnState, WkDataTableStateColumns } from "@components/data-table/data-table.types";

@Injectable()
export class WkDataTablePersistenceService {
    private static readonly VERSION = 1;

    private readonly dataTableId = inject(WK_DATATABLE_ID);

    private persistenceId: string = "";

    public setId(persistenceId: string): void {
        this.persistenceId = persistenceId;
    }

    public load(): WkDataTableStateColumns | undefined {
        const rawState = localStorage.getItem(this.getKey());
        if (rawState === null) return undefined;

        let parsedState: unknown;
        try {
            parsedState = JSON.parse(rawState);
            if (!this.isStoredState(parsedState)) return {};
        } catch {
            return {};
        }

        return parsedState.columns;
    }

    public save(columns: WkDataTableStateColumns): void {
        const state: WkDataTableStoredColumnState = {
            version: WkDataTablePersistenceService.VERSION,
            columns: columns,
        };

        localStorage.setItem(this.getKey(), JSON.stringify(state));
    }

    public clear(): void {
        localStorage.removeItem(this.getKey());
    }

    public getKey(): string {
        return `${this.persistenceId}_${this.dataTableId}`;
    }

    private isStoredState(value: unknown): value is WkDataTableStoredColumnState {
        if (!value || typeof value !== "object") return false;

        const state = value as Partial<WkDataTableStoredColumnState>;
        return state.version === WkDataTablePersistenceService.VERSION && !!state.columns && typeof state.columns === "object";
    }
}
